import React, { memo } from 'react'

import { Icon, Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

function CheckIcon({ size = 'small' }) {
  return <Icon svgComponent={Verified} color="primary" size={size} notSpaced />
}

CheckIcon.propTypes = {
  size: oneOf(['small', 'tiny']),
}

export default memo(CheckIcon)
